module.exports = __webpack_public_path__ + "media/smart_sales/canan_photo-4eff111f.webp";